export class  ActionItemSearch{
    eQMSScopes?:string[];
    status?:string[];
    dueDate?:Date[];
    assignedUser?:string[];
    verifier?:string[];
    type?:string[];
    searchText?: string;
}